import axios from "axios";

import { CommisionProps } from "../../../../interfaces/Commission/types";
import { RestApiState } from "../../../../interfaces/Rest/types";
import { getCsrftoken } from "../../../../helpers/csfrToken";


export const updateCommissionData = (
    serialNumber: string,
    role: string,
    data: FormData | Record<string, unknown>,
    statusSetter: (value: RestApiState) => void,
    onSuccess?: (data: CommisionProps) => void,
): void => {
    const isFormData = data instanceof FormData;
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            ...(isFormData ? {} : { 'Content-Type': 'multipart/form-data' }),
        },
        withCredentials: true
    }
    axios.put<CommisionProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v2/acb/${serialNumber}/commission`, data , headers)
        .then(response => {
                if (response.status === 200) {
                    onSuccess?.(response.data)
                    statusSetter(RestApiState.Success)
                }
            }
        )
        .catch(error => {
            console.error('Error fetching accumulator details:', error)
            if (error.response.status === 400) {
                statusSetter(RestApiState.BadRequest)
            } else if (error.response.status === 500) {
                statusSetter(RestApiState.ServerError)
            } else {
                statusSetter(RestApiState.Unknown)
            }
        });
}